import { defineComponent as _defineComponent } from 'vue'
import imgFeedbackUplode from '@/assets/image/feedback_uplode.png'
import imgLogDefult from '@/assets/image/log_defult.png'
import imgMore from '@/assets/image/more.png'
import imgWrite from '@/assets/image/write.png'
import store from '@/store'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import { translate } from '@/util/commonFun'
import { addFeedbackApi, getFeedbackApi } from '@/util/commonFuncs'
import { uploadFileToOss } from '@yige/utils'
import Vue, { getCurrentInstance } from 'vue'
import { onMounted, onUnmounted, reactive, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  showFeedback: {
    type: Boolean,
    default: false,
  },
},
  emits: ['handleFeedback'],
  setup(__props, { expose, emit }) {

const props = __props

const currentComp: any = getCurrentInstance()?.proxy


let open = ref<boolean>(false)
let uid = ref<number>(0)
let modalContent = ref<string>('submit')
let img = reactive({
  imgLogDefult,
  imgWrite,
  imgFeedbackUplode,
  imgMore,
})

let typeOptions = ref(genTypeOptions())
let feedData = reactive({
  relatedModel: [],
  content: '',
  feedbackPhone: '',
  feedbackName: '',
  appType: 3,
  imagesUrlArr: [] as any[],
  uid: 0,
})
let rules = ref(genRulesTip())
let feedform = reactive(
  currentComp.$form.createForm(currentComp?.proxy, { name: 'coordinated' })
)
let ableCommit = ref<boolean>(false)
let previewVisible = ref<boolean>(false)
let previewImage = ref<string>('')
let ossImgArr = ref([] as any[])
let feedbackList = ref([] as any[])
let isShowFeedback = ref<boolean>(true)
let replyImgIdList = ref([] as any[])
let isShowEmpty = ref<boolean>(false)
let isUplodeImgAble = ref<boolean>(false)
let showHandleLoading = ref<boolean>(true)
let showRecordLoading = ref<boolean>(false)

watch(
  () => feedData,
  () => {
    ableCommit.value =
      ossImgArr.value.length <= 6 &&
      !!feedData.relatedModel.length &&
      feedData.content.replaceAll(' ', '').split('').length >= 15 &&
      feedData.content.replaceAll(' ', '').split('').length <= 300
  },
  { immediate: true, deep: true }
)
watch(
  () => props.showFeedback,
  () => {
    open.value = props.showFeedback
  },
  { immediate: true, deep: true }
)
watch(
  () => ossImgArr,
  () => {
    isUplodeImgAble.value = ossImgArr.value.length > 5
  },
  { immediate: true, deep: true }
)

onMounted(() => {
  EventBus.$on(EventBusKey.TRANSLATE, updateTranslate)
})
onUnmounted(() => {
  EventBus.$off(EventBusKey.TRANSLATE, updateTranslate)
})

function handleChange({ fileList }: any) {
  const maxSizeInBytes = 10000000
  const insertImg = fileList[fileList.length - 1]
  if (insertImg?.size > maxSizeInBytes) {
    Vue.prototype.$message({
      message: translate('main.feedBack.picErr'),
      type: 'error',
    })
    return
  }
  ossImgArr.value = fileList
}
function callback(key: string) {
  modalContent.value = key
  getFeedbackData()
}
function displayRender({ labels }: any) {
  return labels[labels.length - 1]
}
function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
function toggleImgIdList(id: number) {
  if (replyImgIdList.value.includes(id)) {
    replyImgIdList.value = replyImgIdList.value.filter((imgID) => imgID != id)
    return
  }
  replyImgIdList.value.push(id)
}
function handleKeypress(event: any) {
  const keyCode = feedData.feedbackPhone.replace(/\D/g, '')
  feedData.feedbackPhone = keyCode
}
function handleCancel() {
  previewVisible.value = false
}
function handleModalCancel() {
  emit('handleFeedback', false)
  ossImgArr.value = []
  modalContent.value = 'submit'
  feedData.relatedModel = []
  feedData.content = ''
}
async function getFeedbackData() {
  showRecordLoading.value = true
  uid.value = store.state.userInfo.id
  feedData.uid = uid.value
  feedData.feedbackName = store.state.userInfo.name
  feedData.feedbackPhone = store.state.userInfo.phone
  let { data: feedbackArr } = await getFeedbackApi({ uid: uid.value })
  feedbackList.value = feedbackArr?.user_feedback
  isShowEmpty.value = !(feedbackList.value?.length > 0)
  showRecordLoading.value = false
}
async function handleFeedback() {
  let addFeedData = { ...feedData }
  feedData.content = ''
  feedData.relatedModel = []
  feedData.imagesUrlArr = []
  showHandleLoading.value = true
  let version = ''
  await Vue.prototype.$get('/latest_bluen_version', {}, (res: any) => {
    if (res.status == 1) {
      version = res.data.version
    }
  })
  const uploadFiles = ossImgArr.value
    .map(({ originFileObj }: any) => {
      if (!originFileObj) return
      return uploadFileToOss(
        originFileObj,
        undefined,
        undefined,
        'cloudPaibanDisclaimerAgreementPicture',
        true
      )
    })
    .filter((file: any) => file)
  ossImgArr.value = []
  Promise.all(uploadFiles).then(async (res) => {
    addFeedData.imagesUrlArr = res
    let result = await addFeedbackApi({
      ...addFeedData,
      relatedModel: addFeedData.relatedModel.join('-'),
      version,
      uid: store.state.userInfo.id,
    })
    emit('handleFeedback', false)
    Vue.prototype.$message({
      message: `${result.msg}`,
      type: `${result.status == 1 ? 'success' : 'error'}`,
    })
  })
}
async function handlePreview(file: any) {
  if (!file.url && !file.preview) {
    file.preview = await getBase64(file.originFileObj)
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
}

/** 存在翻译需要重新生成 */
function genTypeOptions() {
  return [
    {
      label: translate('main.sideBar.materialList'),
      value: '开料清单',
    },
    {
      label: translate('main.sideBar.printTag'),
      value: '打印标签',
    },
    {
      label: translate('main.sideBar.paibanResult'),
      value: '排版方案',
    },
    {
      label: translate('main.sideBar.history'),
      value: '保存历史',
    },
    {
      label: translate('main.head.workeShop'),
      value: '云端生产',
    },
    {
      label: translate('main.sideBar.title'),
      value: '设备对接',
      children: [
        {
          label: translate('common.engraving'),
          value: '雕刻机',
        },
        {
          label: translate('common.electronicSaw'),
          value: '电子据',
        },
        {
          label: translate('common.dock56FDrill'),
          value: '五/六面钻',
        },
        {
          label: translate('common.sideHoleDrill'),
          value: '侧孔机',
        },
        {
          label: translate('common.glassEquip'),
          value: '玻璃切割机',
        },
        {
          label: translate('common.integration'),
          value: '一体机',
        },
        {
          label: translate('common.PTP'),
          value: 'PTP',
        },
      ],
    },
    {
      label: translate('main.head.plankManager'),
      value: '原片管理',
    },
    {
      label: translate('main.head.suplumentManager'),
      value: '补件管理',
    },
    {
      label: translate('main.sideBar.surplusManager'),
      value: '余料管理',
    },
    {
      label: translate('main.head.fileManager'),
      value: '文件管理',
    },
    {
      label: translate('common.other'),
      value: '其他',
    },
  ]
}
/** 存在翻译需要重新生成 */
function genRulesTip() {
  return {
    relatedModel: [
      { required: true, message: translate('main.feedBack.necessary') },
    ],
    content: [
      {
        required: true,
        message: translate('main.feedBack.necessary'),
        trigger: 'blur',
      },
      {
        min: 15,
        max: 300,
        message: translate('main.feedBack.contentErr'),
        trigger: 'blur',
      },
    ],
  }
}
/** 更新翻译 */
function updateTranslate() {
  typeOptions.value = genTypeOptions()
  rules.value = genRulesTip()
}
expose({
  getFeedbackData,
})

return { __sfc: true,currentComp, props, open, uid, modalContent, img, typeOptions, feedData, rules, feedform, ableCommit, previewVisible, previewImage, ossImgArr, feedbackList, isShowFeedback, replyImgIdList, isShowEmpty, isUplodeImgAble, showHandleLoading, showRecordLoading, emit, handleChange, callback, displayRender, getBase64, toggleImgIdList, handleKeypress, handleCancel, handleModalCancel, getFeedbackData, handleFeedback, handlePreview, genTypeOptions, genRulesTip, updateTranslate, imgFeedbackUplode, imgLogDefult, imgMore }
}

})